import { render } from "./BookConsultancySuccess.vue?vue&type=template&id=468bce4d"
import script from "./BookConsultancySuccess.vue?vue&type=script&lang=js"
export * from "./BookConsultancySuccess.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__